import { RightOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import IconHeadset from '@/assets/images/icons/icon-headset.react.svg?react';
import IconLockOn from '@/assets/images/icons/icon-lock-on.react.svg?react';
import IconQrcode from '@/assets/images/icons/icon-qrcode.react.svg?react';
import IconQuestion from '@/assets/images/icons/icon-question.react.svg?react';
import QrcodeImg from '@/assets/images/index/1x/qrcode-img1x.png';
import { ENV } from '@/infrastructure/env-config';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { Aisee } from '@/presentation/layouts/tools/aisee';
import styles from './index.module.scss';

export const ContactUs = () => {
  const history = useHistory();
  const ref = useRef(null);
  const aiseeRef = useRef<{ showAisee: () => void }>(null);

  const disabledRoute = ['/v2/compliance', '/v2/shiply'];

  const showAisee = () => {
    aiseeRef?.current?.showAisee();
  };

  const gotoBusinessConsult = () => {
    history.push('/consult');
  };

  const content = <div className={styles.popoverContent}>
    <ul>
      <li className={styles.qrcodeContent}>
        <div className={styles.icon}><IconQrcode/></div>
        <span>联系我们</span>
        <div className={styles.qrcodeImg}>
          <img src={QrcodeImg} alt=""/>
        </div>
      </li>
      <li onClick={gotoBusinessConsult}>
        <div className={styles.icon} ><IconLockOn/></div><span>商务咨询</span><RightOutlined />
      </li>
      <li onClick={showAisee}><div className={styles.icon}><IconQuestion/></div><span>问题反馈</span><RightOutlined /></li>
    </ul>
  </div>;

  const resourcePack = () => {
    history.push('/resource-pack');
    reportClick(PAGE_ID.indexMain, CUSTOM_ACTIONS.commonEnterBuyResourcePackPage, {
      from: PAGE_ID.indexMain,
    });
  };

  const hide = disabledRoute.includes(window.location.pathname);

  return <div style={{ display: hide ? 'none' : 'block' }}>
    <div ref={ref} className={styles.popup}>
    </div>
    <div className={styles.contact} style={{ bottom: '50%' }}>
      {!ENV.isEu && <div title={'购买资源包'} onClick={resourcePack} className={styles.resourcePack} >
        <ShoppingCartOutlined />
      </div>}

      <Popover getPopupContainer={() => (ref?.current || document.body)} placement="left" content={content} overlayClassName={styles.popover}>
        <div className={styles.headset}>
          <IconHeadset/>
        </div>
      </Popover>
    </div>
    <Aisee ref={aiseeRef}/>
  </div> ;
};
